import { Dispatch, SetStateAction } from 'react';
import { sendGTM, GaActionType } from '@fe-cnyes/fe-common-gtm';
import LinkFactory from '@fe-common-utils/libs/link';
import { RankListItem } from '@fe-news/constants/my-track/type';
import { NewsCategory } from '@fe-news/constants/categories';
import { subMonths } from 'date-fns';
// type
import { MyCollectionProductType } from '@fe-news/constants/my-track/type';

const { newsChannelLink, newsTagLink, popTopicDetailLink, newsDetailLink } = LinkFactory;

export const isBookmark = (myCollectionDataItemsIdArray: string[], id: string): boolean => {
  return myCollectionDataItemsIdArray?.includes(id);
};

export const handleFollow = async ({
  isLoggedIn,
  isBookmarked,
  newsId,
  dataLength,
  limit,
  productType,
  setIsSaved,
  setIsClose,
  setIsSuccess,
  handleDelete,
  handlePost,
  onClickLoginModalOpen,
  gtmEvent
}: {
  isLoggedIn: boolean;
  isBookmarked: boolean;
  newsId: string;
  dataLength: number;
  limit: number;
  productType: MyCollectionProductType;
  setIsSaved: Dispatch<SetStateAction<boolean>>;
  setIsClose: Dispatch<SetStateAction<boolean>>;
  setIsSuccess: Dispatch<SetStateAction<boolean>>;
  handleDelete: () => Promise<string>;
  handlePost: () => Promise<string>;
  onClickLoginModalOpen: () => void;
  gtmEvent?: GaActionType;
}) => {
  if (isLoggedIn) {
    try {
      if (isBookmarked) {
        setIsSaved(false);
        const responseMessage = await handleDelete();
        setIsSaved(!(responseMessage === '成功'));
      } else {
        if (dataLength >= limit) {
          setIsClose(false);
          return;
        }
        setIsSaved(true);
        const responseMessage = await handlePost();
        if (responseMessage !== '成功') {
          throw new TypeError(JSON.stringify({ message: responseMessage }));
        }
        setIsSaved(responseMessage === '成功');
        setIsSuccess(true);
        gtmEvent && sendGTM(gtmEvent);
      }
    } catch (error) {
      if (isBookmarked) {
        setIsSaved(true);
        console.error(`[ACTION ERROR]: delete ${productType} error : ${newsId}`, error);
      } else {
        if (error instanceof Error && JSON.parse(error.message).message === '超出資料上限') {
          setIsClose(false);
        }
        setIsSaved(false);
        setIsSuccess(false);
        console.error(`[ACTION ERROR]: add ${productType} error : ${newsId}`, error);
      }
    }
  } else {
    onClickLoginModalOpen();
  }
};

export const ONE_MONTHS_AGO = Math.floor(new Date(subMonths(new Date(), 1)).getTime() / 1000);

const RANKING_LIST_BASE_COUNT = 10;

const switchCategory = (category: NewsCategory) => {
  let baseUrl = newsChannelLink;
  let baseType = 'NewsArticle';
  let baseName = '';

  switch (category) {
    case NewsCategory.MY_TAG:
      baseUrl = newsTagLink;
      baseType = 'CollectionPage';
      baseName = '# replacedName 新聞';
      break;
    case NewsCategory.MY_POP_TOPIC:
      baseUrl = popTopicDetailLink;
      baseType = 'NewsArticle';
      baseName = 'replacedName';
      break;
    case NewsCategory.NEWS_COLLECT:
      baseUrl = newsDetailLink;
      baseType = 'NewsArticle';
      baseName = 'replacedName';
      break;
  }

  return { baseUrl, baseType, baseName };
};

export const getMainEntityItemsAndData = (rankingListData: RankListItem[], category: NewsCategory) => {
  let mainEntityItems: MainEntityItem[] = [];
  const { baseUrl, baseType, baseName } = switchCategory(category);

  mainEntityItems = rankingListData.slice(0, RANKING_LIST_BASE_COUNT).map(item => {
    const baseResult: MainEntityItem = {
      '@type': baseType,
      url: `${baseUrl}/${item.productId}`
    };
    if (baseType === 'CollectionPage') {
      baseResult.name = baseName.replace('replacedName', `${item.productId}`);
    }
    if (baseType === 'NewsArticle') {
      baseResult.headline = baseName.replace('replacedName', `${item.productId}`);
    }
    return baseResult;
  });

  return { mainEntityItems, slicedData: rankingListData.slice(0, RANKING_LIST_BASE_COUNT) };
};
